module.exports = __webpack_public_path__ + "img/firel.d8a217bb.svg";